// // NotesTable.js
// import React, { useState, useEffect } from 'react';
// import axios from '../utils/axiosConfig';
// import {
//   Table,
//   Box,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   TablePagination,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   IconButton,
//   Snackbar,
//   SnackbarContent,
//   TextField,
// } from '@mui/material';
// import DeleteIcon from '@mui/icons-material/Delete';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import AddIcon from '@mui/icons-material/Add';

// const NotesTable = ({ file }) => {
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(100);
//   const [notes, setNotes] = useState([]);
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [newNote, setNewNote] = useState('');
//   const [newNoteDate, setNewNoteDate] = useState('');
//   const [showNewNoteField, setShowNewNoteField] = useState(false);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');

//   useEffect(() => {
//     if (file?._id) {
//       fetchNotes();
//     }
//   }, [file]);

//   const fetchNotes = async () => {
//     try {
//       const response = await axios.get(`/api/files/${file._id}`);
//       setNotes(response.data.notes);
//     } catch (error) {
//       console.error("Error fetching notes:", error);
//     }
//   };

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const handleOpenNotes = () => {
//     setSelectedFile(file);
//   };

//   const handleCloseNotes = () => {
//     setSelectedFile(null);
//     setNewNote("");
//     setNewNoteDate("");
//     setShowNewNoteField(false);
//   };

//   const handleAddNote = () => {
//     setNewNoteDate(new Date().toLocaleDateString());
//     setShowNewNoteField(true);
//   };

//   const handleSaveAllNotes = async () => {
//     try {
//       const updatePromises = notes.map((note) =>
//         axios.put(`/api/files/${file._id}/notes/${note._id}`, {
//           content: note.content,
//         })
//       );

//       if (newNote) {
//         updatePromises.push(
//           axios.post(`/api/files/${file._id}/notes`, {
//             content: newNote,
//             date: new Date(),
//           })
//         );
//       }

//       await Promise.all(updatePromises);
//       await fetchNotes();
//       setNewNote("");
//       setNewNoteDate("");
//       setShowNewNoteField(false);
//       setSnackbarMessage("Notes saved successfully");
//       setSnackbarOpen(true);
//     } catch (error) {
//       console.error("Error saving notes:", error);
//     }
//   };

//   const handleDeleteNote = async (noteId) => {
//     try {
//       await axios.delete(`/api/files/${file._id}/notes/${noteId}`);
//       await fetchNotes();
//     } catch (error) {
//       console.error("Error deleting note:", error);
//     }
//   };

//   return (
//     <Box>
        
//       <TableContainer>
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell>Date</TableCell>
//               <TableCell>Content</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {notes
//               .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//               .map((note) => (
//                 <TableRow 
//                   key={note._id}
//                   onClick={() => handleOpenNotes()}
//                   style={{ cursor: 'pointer' }}
//                 >
//                   <TableCell>{new Date(note.date).toLocaleDateString()}</TableCell>
//                   <TableCell>{note.content}</TableCell>
//                 </TableRow>
//               ))}
//           </TableBody>
//         </Table>
//       </TableContainer>
//       <TablePagination
//         rowsPerPageOptions={[5, 10, 25]}
//         component="div"
//         count={notes.length}
//         rowsPerPage={rowsPerPage}
//         page={page}
//         onPageChange={handleChangePage}
//         onRowsPerPageChange={handleChangeRowsPerPage}
//       />

//       <Dialog
//         open={!!selectedFile}
//         onClose={handleCloseNotes}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle sx={{ backgroundColor: "#2A428C", color: "#fff" }}>
//           Notes for {file?.fileNo} - {file?.name}
//         </DialogTitle>
//         <DialogContent>
//           <div style={{ paddingTop: "2em" }}>
//             {notes.map((note) => (
//               <div
//                 key={note._id}
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   marginBottom: "1em",
//                 }}
//               >
//                 <div style={{ marginRight: "1em", color: "#888" }}>
//                   {new Date(note.date).toLocaleDateString()}
//                 </div>
//                 <TextField
//                   fullWidth
//                   multiline
//                   value={note.content}
//                   onChange={(e) => {
//                     const updatedNotes = notes.map((n) =>
//                       n._id === note._id ? { ...n, content: e.target.value } : n
//                     );
//                     setNotes(updatedNotes);
//                   }}
//                 />
//                 <IconButton
//                   onClick={() => handleDeleteNote(note._id)}
//                   color="secondary"
//                 >
//                   <DeleteIcon />
//                 </IconButton>
//               </div>
//             ))}
//           </div>
//           {showNewNoteField && (
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 marginBottom: "1em",
//                 paddingBottom: "1em",
//               }}
//             >
//               <div style={{ marginRight: "1em", color: "#888" }}>
//                 {newNoteDate}
//               </div>
//               <TextField
//                 fullWidth
//                 multiline
//                 rows={4}
//                 value={newNote}
//                 onChange={(e) => setNewNote(e.target.value)}
//                 placeholder="Add a new note"
//                 style={{ marginTop: "1em" }}
//               />
//               <IconButton
//                 onClick={() => {
//                   setNewNote("");
//                   setShowNewNoteField(false);
//                 }}
//                 color="secondary"
//               >
//                 <DeleteIcon />
//               </IconButton>
//             </div>
//           )}
//         </DialogContent>
//         <DialogActions style={{ backgroundColor: "#f5f5f5", paddingRight: "3rem" }}>
//           <Button
//             onClick={handleAddNote}
//             sx={{
//               backgroundColor: "#4a76ff",
//               textTransform: "capitalize",
//               borderRadius: 50,
//               padding: "2px 30px",
//               fontSize: "0.75rem",
//             }}
//             variant="contained"
//           >
//             Add Note
//           </Button>
//           <Button
//             onClick={handleSaveAllNotes}
//             sx={{
//               backgroundColor: "#4a76ff",
//               textTransform: "capitalize",
//               borderRadius: 50,
//               padding: "2px 30px",
//               fontSize: "0.75rem",
//             }}
//             variant="contained"
//           >
//             Save
//           </Button>
//           <Button
//             onClick={handleCloseNotes}
//             sx={{
//               backgroundColor: "#4a76ff",
//               textTransform: "capitalize",
//               borderRadius: 50,
//               padding: "2px 30px",
//               fontSize: "0.75rem",
//             }}
//             variant="contained"
//           >
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={6000}
//         onClose={() => setSnackbarOpen(false)}
//       >
//         <SnackbarContent
//           message={
//             <span style={{ display: "flex", alignItems: "center" }}>
//               <CheckCircleIcon style={{ marginRight: "8px" }} />
//               {snackbarMessage}
//             </span>
//           }
//           style={{
//             backgroundColor: "#d4edda",
//             color: "#155724",
//           }}
//         />
//       </Snackbar>
//     </Box>
//   );
// };

// export default NotesTable;




import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import { Table, TableBody, TableCell, Box, TableContainer, TableHead, TableRow, TablePagination, Paper, Avatar, IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import { windowsTableStyles } from "../styles/windowsTableStyles";
import { smallTitle } from "../styles/typography";
import { CircularProgress } from '@mui/material';
import { formatDate } from "../utils/dateUtils";
import axios from "../utils/axiosConfig";

const tableStyles = windowsTableStyles();
const NotesTable = ({ notes, page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, handleOpenNotes, file, onDeleteNote }) => {
  const { t } = useTranslation(['forms', 'common', 'buttons']);
  const [hoveredNoteId, setHoveredNoteId] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [noteToDelete, setNoteToDelete] = useState(null);

  const formatDateTime = (dateString) => {
    if (!dateString) return '';

    const date = new Date(dateString);
    const formattedDate = formatDate(date);

    const formattedTime = date.toLocaleTimeString(undefined, {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });

    return `${formattedDate}, ${formattedTime}`;
  };

  const stringToColor = (string) => {
    if (!string) return "#ccc"; // Default gray color if string is empty

    let hash = 0;
    for (let i = 0; i < string.length; i++) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xff;
      color += ("00" + value.toString(16)).slice(-2);
    }

    return color;
  };

  const handleDeleteClick = (noteId, e) => {
    e.stopPropagation();
    setNoteToDelete(noteId);
    setDeleteDialogOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (noteToDelete && file?._id) {
      try {
        if (onDeleteNote) {
          await onDeleteNote(noteToDelete);
        } else {
          await axios.delete(`/api/files/${file._id}/notes/${noteToDelete}`);
        }
      } catch (error) {
        console.error('Error deleting note:', error);
        alert(error?.message || 'Failed to delete note. Please try again.');
      }
    }
    setDeleteDialogOpen(false);
    setNoteToDelete(null);
  };

  const handleCancelDelete = () => {
    setDeleteDialogOpen(false);
    setNoteToDelete(null);
  };
  
  return (
    <Box sx={{ backgroundColor: "white", padding: "32px 24px " }}>
      <TableContainer>
      {notes.length > 0 ? (
      <Table sx={{...tableStyles.container, border: "1px solid #d1d1d1"}}
          size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={tableStyles.headerCell}>{t('forms:billing.table_headers.date')}</TableCell>
              <TableCell sx={tableStyles.headerCell}>{t('forms:billing.table_headers.author')}</TableCell>
              <TableCell sx={tableStyles.headerCell}>{t('forms:billing.table_headers.content')}</TableCell>
              <TableCell sx={tableStyles.headerCell}>{t('common:actions')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {notes.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((note) => (
              <TableRow 
                key={note._id} 
                onMouseEnter={() => setHoveredNoteId(note._id)}
                onMouseLeave={() => setHoveredNoteId(null)}
                onClick={() => handleOpenNotes()} 
                sx={{...tableStyles.row, cursor: 'pointer', "&:hover": { backgroundColor: "#ecf5fb" } }}
              >
                <TableCell sx={tableStyles.cell}>{formatDateTime(note.date)}</TableCell>
                <TableCell sx={tableStyles.cell}>
                  {note.author ? (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Avatar
                        alt={note.author.firstName || 'Unknown'}
                        src={note.author.avatar ? note.author.avatar : ""}
                        sx={{
                          fontFamily: '"Fira Sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
                          fontSize: "7.8px",
                          height: "1rem",
                          width: "1rem",
                          backgroundColor: note.author.avatar
                            ? "transparent"
                            : stringToColor(note.author.firstName || note.author.businessName || 'Unknown'),
                          color: "#fff",
                        }}
                      >
                        {!note.author.avatar &&
                          `${note.author.firstName ? note.author.firstName.charAt(0) : ''}${note.author.lastName ? note.author.lastName.charAt(0) : note.author.businessName ? note.author.businessName.charAt(0) : 'U'}`}
                      </Avatar>
                      {`${note.author.firstName || ''} ${note.author.lastName || ''}`.trim() || note.author.businessName || 'Unknown'}
                    </Box>
                  ) : (
                    "Unknown"
                  )}
                </TableCell>
                <TableCell sx={tableStyles.cell}>{note.content}</TableCell>
                <TableCell sx={tableStyles.cell}>
                  {hoveredNoteId === note._id && (
                    <IconButton
                      size="small"
                      onClick={(e) => handleDeleteClick(note._id, e)}
                      sx={{
                        padding: "2px",
                        color: "rgb(229, 32, 46)",
                        "&:hover": {
                          backgroundColor: "rgba(229, 32, 46, 0.1)",
                        },
                      }}
                    >
                      <DeleteOutline sx={{ fontSize: "16px" }} />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        ) : (
          <Box
            sx={{ ...smallTitle, padding: "32px 24px", textAlign: "center" }}
          >
            {t('common:no_data_available')}
          </Box>
        )}
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 100]}
        component="div"
        count={notes.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <Dialog
        open={deleteDialogOpen}
        onClose={handleCancelDelete}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title">
          {t('common:confirm_delete')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-dialog-description">
            {t('common:confirm_delete_note')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete} color="primary">
            {t('buttons:secondary.cancel')}
          </Button>
          <Button onClick={handleConfirmDelete} color="error" variant="contained" autoFocus>
            {t('buttons:danger.delete')}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default NotesTable;